






































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import Tenant from '@/store/entities/tenant';
@Component
export default class CreateTenant extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    tenant:Tenant=new Tenant();
    save(){
        (this.$refs.tenantForm as any).validate(async (valid:boolean)=>{
            if(valid){
                await this.$store.dispatch({
                    type:'tenant/create',
                    data:this.tenant
                });
                (this.$refs.tenantForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
            }
        })
    }
    cancel(){
        (this.$refs.tenantForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    tenantRule={
        name:[{required: true,message:this.L('不能为空',undefined,this.L('TenantName')),trigger: 'blur'}],
        tenancyName:[{required:true,message:this.L('不能为空',undefined,this.L('TenancyName')),trigger: 'blur'}],
        adminEmailAddress:[{required:true,message:this.L('不能为空',undefined,this.L('AdminEmailAddress')),trigger: 'blur'},{type: 'email'}],
        passWord:[{required:true,message:this.L('不能为空',undefined,this.L('管理员密码')),trigger: 'blur'}]
    }
}
